import { localizer } from "../../Translator"


export default class Roles {
 /// <summary>
    /// System administrator. 
    /// Overall accesss to information about all working groups and factories.
    /// </summary>
    static get ROLE_SYSADMIN() { return { Name: 'SYSADMIN', Description: localizer.InviteRoleDescriptionSysAdmin } }
    /// <summary>
    /// Factory administrator. 
    /// Access to all features within a printing factory.
    /// </summary>
    static get ROLE_FACTORYADMIN() { return { Name:'FACTORYADMIN', Description: localizer.InviteRoleDescriptionFactoryAdmin } }

    /// <summary>
    /// Factory operator. 
    /// Access to daily tools within a printing factory.
    /// </summary>
    static get ROLE_FACTORYOPER() { return { Name:'FACTORYOPER', Description: localizer.InviteRoleDescriptionFactoryOper } }

    /// <summary>
    /// Working group (billable) administrator. 
    /// External user in charge of the management of a working group
    /// and some accessibility to dependant working groups falling below.
    /// </summary>
    static get ROLE_ADMIN() { return { Name:'ADMIN', Description: localizer.InviteRoleDescriptionAdmin } }

    // <summary>
        ///  Working group (billable) administrator. 
        /// External user in charge of the management of a working group
        /// and some accessibility to dependant working groups falling below.
        /// </summary>
        static get ROLE_SUPERVISOR() { return { Name: 'SUPERVISOR', Description: localizer.InviteRoleDescriptionSupervisor } }
        
    /// <summary>
    /// Working group (billable) standard user.
    /// External user for sending shipments and receive returns.
    /// </summary>
    static get ROLE_USER() { return { Name:'USER', Description: localizer.InviteRoleDescriptionUser } }

}        
   


// WEBPACK FOOTER //
// ./src/components/Utilities/Roles.js